import React, { createContext, useContext } from 'react';
interface RegistrationContextType {
  openPopup: () => void;
}
const RegistrationContext = createContext<RegistrationContextType | undefined>(undefined);
export const RegistrationProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const openPopup = () => {
    window.location.href = 'https://info.stresslessdogs.nl/webinar-mc-adv2';
  };
  return <RegistrationContext.Provider value={{
    openPopup
  }} data-id="element-354" data-mp="1934ks11wyc3o">
      {children}
    </RegistrationContext.Provider>;
};
export const useRegistration = (): RegistrationContextType => {
  const context = useContext(RegistrationContext);
  if (context === undefined) {
    throw new Error('useRegistration must be used within a RegistrationProvider');
  }
  return context;
};